import { useMemo } from 'react';

import { Settings } from 'utils/constants/dynamicSettings';

import useTrls from 'hooks/translation/useTrls';
import useSettings from 'hooks/useSettings';

import { AuctionAutoStrategySettings } from 'components/AuctionBuilder/types/auctionAutoStrategySettings';

import { BiddingStrategy } from 'store/models/auctionData';

const TrlKeys = {
    [BiddingStrategy.Auto]: {
        applicationsGrowthTag: 'AuctionBuilder.BiddingStrategySelect.BiddingStrategyCard.auto.applicationsGrowthTag',
        applicationsCostReductionTag:
            'AuctionBuilder.BiddingStrategySelect.BiddingStrategyCard.auto.applicationsCostReductionTag',
    },
};

type BiddingStrategyTags = Record<BiddingStrategy, string[] | undefined>;

export const useBiddingStrategyTags = (): BiddingStrategyTags => {
    const trls = useTrls();
    const settings = useSettings();

    const autoStrategyBenefits = settings(Settings.AuctionAutoStrategySettings) as AuctionAutoStrategySettings | null;
    const { applicationsGrowthPercent, applicationsCostReductionPercent } = autoStrategyBenefits || {};

    return useMemo(
        () => ({
            [BiddingStrategy.Auto]:
                applicationsGrowthPercent && applicationsCostReductionPercent
                    ? [
                          trls(TrlKeys[BiddingStrategy.Auto].applicationsGrowthTag, [applicationsGrowthPercent]),
                          trls(TrlKeys[BiddingStrategy.Auto].applicationsCostReductionTag, [
                              applicationsCostReductionPercent,
                          ]),
                      ]
                    : undefined,
            [BiddingStrategy.Manual]: undefined,
        }),
        [applicationsGrowthPercent, applicationsCostReductionPercent, trls]
    );
};
